import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AsideItemWithOverlayComponent } from './aside-item-with-overlay.component';


@Injectable(
    { providedIn: 'root'}
)
export class AsideItemService {

    public $open: Subject<AsideItemWithOverlayComponent> = new Subject();

}
